<template>
  <input type="text">
</template>

<script>
  export default {
    name: "date-input"
  }
</script>

<style scoped>

</style>
